import { Grid } from "@material-ui/core";
import React, { Component } from "react";
import './styles/work.css';

import WorkItem from '../components/WorkItem';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getWorks } from '../redux/actions/dataActions';

class work extends Component {

    componentDidMount(){
      this.props.getWorks()
    }

  render() {

    const { data: { works }} = this.props

    let worksMarkup = works ? (
    works.map(work => <WorkItem work={work}/>)
    ) : <p>Loading...</p>

    return (
      <div className="WorkMain">
        <h1>Work</h1>
        <Grid container>
            <Grid item sm={8} xs={12}>
                {worksMarkup}
            </Grid>
        </Grid>
      </div>
    );
  }
}

work.propTypes = {
  getWorks: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired
}

const mapStateToProps = (state) => ({
  data: state.data
});

const mapActionsToProps = {
  getWorks
}

export default connect(mapStateToProps, mapActionsToProps)(work);
